import { ChargingPaymentMethod, PaymentMethodEnum } from '@/types/Payment'

export enum ChargingSessionInAppNotificationStatus {
  NOT_STARTED = 'NOT_STARTED',
  WAITING_PAYMENT = 'WAIT_PAYMENT',
  READY_TO_START = 'READY_TO_START',
  FAILED_PAYMENT = 'FAILED_PAYMENT',
  IN_PROGRESS = 'IN_PROGRESS',
  FAILED = 'FAILED',
  FINISHING = 'FINISHING',
  IDLE = 'IDLE',
  FINISHED = 'FINISHED',
}

export const CHARGING_START_PENDING_STATUSES = [
  ChargingSessionInAppNotificationStatus.NOT_STARTED,
  ChargingSessionInAppNotificationStatus.WAITING_PAYMENT,
]

export const CHARGING_START_SUCCESS_STATUSES = [
  ChargingSessionInAppNotificationStatus.READY_TO_START,
  ChargingSessionInAppNotificationStatus.IN_PROGRESS,
]

export const CHARGING_FINISHED_STATUSES = [
  ChargingSessionInAppNotificationStatus.FINISHED,
  ChargingSessionInAppNotificationStatus.FAILED,
  ChargingSessionInAppNotificationStatus.FAILED_PAYMENT,
]

export const ACTIVE_BANNER_VISIBLE_STATUSES = [
  ChargingSessionInAppNotificationStatus.IN_PROGRESS,
  ChargingSessionInAppNotificationStatus.IDLE,
  ...CHARGING_FINISHED_STATUSES,
]

const EXTERNAL_PAYMENT_METHODS: ChargingPaymentMethod[] = [PaymentMethodEnum.PIX, PaymentMethodEnum.CREDIT_CARD]

export const isAwaitingExternalPayment = (
  payload: Pick<ChargingSessionInAppNotificationPayload, 'status' | 'payment_method'> | null | undefined
): boolean =>
  payload?.status === ChargingSessionInAppNotificationStatus.WAITING_PAYMENT &&
  !!payload.payment_method &&
  EXTERNAL_PAYMENT_METHODS.includes(payload.payment_method)

export type PixData = {
  code: string
  image: string
}

export type ChargingSessionInAppNotificationAuthenticatePayload = {
  charging_point_id?: number
}

export type ChargingSessionInAppNotificationPayload = {
  start_time: string
  charge_started_at: string | null
  end_time: string | null
  charge_finished_at: string | null
  kwh_delivered: number
  kwh_cost: string | null
  activation_fee_cost: string | null
  total_cost: string | null
  status: ChargingSessionInAppNotificationStatus
  session_id: number
  idle_time_minutes: number | null
  idle_cost: string | null
  idle_start_time: string | null
  idle_tolerance_time: number | null
  idle_rate: number | null
  payment_method: ChargingPaymentMethod | null
  payment_amount: number | null
  payment_wallet_value: number
  payment_external_value: number
  payment_pix_data: PixData | null
  station_id: number
  charging_point_id: number
  had_pending_balance: boolean | null
  pending_balance: number | null
  refund_amount: number | null
  pending_external_refund?: number | null
  pending_amount_after: number | null
  used_wallet_balance: boolean | null
  wallet_balance_before: number | null
  final_wallet_balance: number | null
  effective_wallet_balance: number | null
  wallet_debited: string
  refunded_to_wallet: string
  refunded_externally: string
  soc: number | null
  power_active: number | null
  summary?: string
}
